// extracted by mini-css-extract-plugin
export default {"pageCard":"PageCard_pageCard__0pPpB"};